<template>
  <div class="card mb-4">
    <div class="card-header">{{ $t("Change Password") }}</div>
    <div class="card-body">
      <b-form @submit.prevent="handleSubmit">
        <b-row>
          <b-col md="4">
            <b-form-group
              label="New Password"
              :state="getFieldState('password')"
              invalid-feedback="Password is required and must be at least 8 characters."
            >
              <b-form-input
                type="password"
                v-model="form.password"
                :state="getFieldState('password')"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Confirm Password"
              :state="getFieldState('password_confirmation')"
              invalid-feedback="Password confirmation does not match."
            >
              <b-form-input
                type="password"
                v-model="form.password_confirmation"
                :state="getFieldState('password_confirmation')"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="d-flex align-items-end">
            <b-button :disabled="loading" variant="primary" type="submit" class="form-group">
              <span v-if="loading" class="spinner-border spinner-border-sm" role="status"></span>
              {{ $t("Change Password") }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ChangePassword",
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        password: "",
        password_confirmation: ""
      },
      errors: {},
      loading: false
    };
  },
  methods: {
    getFieldState(field) {
      return this.errors[field] === undefined ? null : false;
    },
    async handleSubmit() {
      this.loading = true;
      this.errors = {};

      try {
        await axios.put(`/api/users/${this.userId}/set-password`, this.form);

        this.$bvToast.toast("Password updated successfully!", {
          title: "Success",
          variant: "success",
          solid: true
        });

        this.form.password = "";
        this.form.password_confirmation = "";
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.$bvToast.toast("An error occurred. Please try again.", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
